// Handles the return from Emergent-managed Google OAuth. Reads the session_id
// from the URL fragment (once, synchronously) and exchanges it via our backend
// for a persistent session cookie, then jumps into /account.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { customerApi, useCustomerAuth } from "@/lib/customerAuth";

export default function AuthCallback() {
    const location = useLocation();
    const nav = useNavigate();
    const { refresh } = useCustomerAuth();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const params = new URLSearchParams(location.hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            nav("/signin", { replace: true });
            return;
        }
        (async () => {
            try {
                await customerApi.post(
                    "/customer/auth/google-session",
                    {},
                    { headers: { "X-Session-ID": sessionId } }
                );
                // Clear the fragment so refresh doesn't retry
                window.history.replaceState({}, "", window.location.pathname);
                await refresh();
                toast.success("Welcome to Serenity Cove");
                nav("/account", { replace: true });
            } catch (e) {
                toast.error("Google sign-in failed. Please try again.");
                nav("/signin", { replace: true });
            }
        })();
    }, [location.hash, nav, refresh]);

    return (
        <div className="min-h-screen bg-ivory flex items-center justify-center" data-testid="auth-callback">
            <div className="text-center">
                <div className="text-[10px] uppercase tracking-[0.32em] text-gold">Serenity Cove</div>
                <p className="mt-4 text-navy/70 text-sm">Completing sign-in…</p>
            </div>
        </div>
    );
}
